import Swiper, {EffectFade} from 'swiper';
const breakpoint = window.matchMedia('(max-width: 767px)');
let mySwiper;
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const breakpointChecker = function () {
    if (breakpoint.matches === true) {
        $('.section-tabs .item-tab').removeClass('-active');
        $('.section-tabs .tabs-controls .item-content').slideUp();
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
    } else if (breakpoint.matches === false) {
        $('.section-tabs .item-tab').removeClass('-active');
        $('.section-tabs .item-tab[data-tab="0"]').addClass('-active');
        $('.section-tabs .tabs-controls .item-content').slideUp();
        $('.section-tabs .tabs-controls .item-content .animated-img-box').removeClass('-animated');
        return enableSwiper();
    }
};

const enableSwiper = function () {
    mySwiper = new Swiper('.section-tabs .tabs-content', {
        modules: [EffectFade],
        loop: false,
        slidesPerView: 1,
        keyboardControl: false,
        grabCursor: false,
        effect: 'fade',
        autoHeight: true,
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
        on: {
            beforeSlideChangeStart: function () {
                $('.section-tabs .tabs-content .show-more.-active').removeClass('-active');
                $('.section-tabs .tabs-content .hidden-text.-active').slideUp().removeClass('-active');
            },
        },
    });
};

breakpoint.addListener(breakpointChecker);

breakpointChecker();

$('.section-tabs .item-tab').on('click', function (e) {
    if (breakpoint.matches === false && $(this).hasClass('-active')) return;
    let this_numb = $(this).data('tab');
    let header_h = $('.site-header').innerHeight() - 1;
    let check_active = $(this).hasClass('-active');
    if (breakpoint.matches === false) {
        $(this).closest('.section-tabs').find('.item-tab').removeClass('-active');
        $(this).addClass('-active');
        mySwiper.slideTo(this_numb);
    } else {
        let current_content = $(this).closest('.section-tabs').find('.tabs-controls .item-content[data-content="' + this_numb + '"]');
        let animated_image = $(this).closest('.section-tabs').find('.tabs-controls .item-content[data-content="' + this_numb + '"] .animated-img-box')[0];
        $(this).closest('.section-tabs').find('.tabs-controls .item-content').slideUp(0);
        $(this).closest('.section-tabs').find('.tabs-controls .item-content .animated-img-box').removeClass('-animated');
        if(!check_active) {
            $(this).closest('.section-tabs').find('.item-tab').removeClass('-active');
            $(this).addClass('-active');
            current_content.slideDown();
            $('html,body').animate({
                scrollTop: current_content.offset().top - header_h
            }, 500);
            gsap.timeline({
                scrollTrigger: {
                    trigger: animated_image,
                    endTrigger: animated_image,
                    start: 'top 50%',
                    end: 'bottom 50%',
                    scrub: true,
                    onToggle: function (self) {
                        if (!animated_image.classList.contains('-animated') && self.isActive) {
                            animated_image.classList.add("-animated");
                        }
                    },
                }
            });
        } else {
            $(this).removeClass('-active');
        }
    }
});

$('.section-tabs .show-more').on('click', function (e) {
    e.preventDefault();
    if($(this).hasClass('-active')) {
        $(this).closest('.item-content').find('.hidden-text').slideUp().removeClass('-active');
        $(this).removeClass('-active');
    } else {
        $(this).closest('.item-content').find('.hidden-text').slideDown().addClass('-active');
        $(this).addClass('-active');
    }
    mySwiper.updateAutoHeight(300)
});

$(window).resize(function () {
    breakpointChecker();
    mySwiper.updateAutoHeight(300)
});